
import InfoFinanciera from "@/validation/InfoFinanciera";
import useVuelidate from "@vuelidate/core";
import { defineComponent, ref, onMounted } from "vue";
import { useStore } from "vuex";
import CurrencyInput from "./CurrencyInput.vue";
import "@/assets/sass/components/DueDiligence/_infoFinanciera.scss";

export default defineComponent({
  components: { CurrencyInput },
  props: {
    scopeFinanciera: String,
  },
  setup(props, { emit }) {
    const store = useStore();
    const estadosFinancieros = ref<any[]>([]);
    const justificarIngresos = ref(false);

    const [objetoFinanciera, reglasValidacion] =
      new InfoFinanciera().ObtenerReglasValidacion();

    function validarIngresos() {
      const operacionales = Number(objetoFinanciera.IngresosOperacionales) || 0;
      const noOperacionales = Number(objetoFinanciera.IngresosNoOperacionales) || 0;
      justificarIngresos.value = noOperacionales >= operacionales;

      if(!justificarIngresos.value){
        objetoFinanciera.JustificacionIngresos = "";
      }
    };

    const validacionFinanciera = useVuelidate(
      reglasValidacion,
      objetoFinanciera,
      { $scope: props.scopeFinanciera }
    );

    function generarNombreArchivo(
      archivo: { name: string },
      indice: number
    ): string {
      const partesNombre = archivo.name.split(".");
      const extension = partesNombre.length > 1 ? partesNombre.pop() : "";
      const tipoIdentificacion = localStorage.getItem("TipoIdenticacionDD") ?? "";
      const numeroIdentificacion = localStorage.getItem("NumeroIdentificacionDD") ?? "";

      return `EstadoFinanciero_${tipoIdentificacion}_${numeroIdentificacion}_${indice}.${extension}`;
    }

    function cargarEstadoFinanciero(file: any, fileList: any) {
      const files = Array.isArray(file) ? file : [file];

      files.forEach((fileItem) => {
        objetoFinanciera.TamañoArchivo += Number(fileItem.size);

        objetoFinanciera.Documentos.ExtensionesArchivos.push({
          Extension: fileItem.raw.type,
          Id: fileItem.uid,
        });

        const indice = objetoFinanciera.NombresArchivos.length + 1;
        const nombreArchivo = generarNombreArchivo(fileItem, indice);
        objetoFinanciera.Archivos.append(fileItem.uid, fileItem.raw, nombreArchivo);
        
        objetoFinanciera.NombresArchivos.push({
          Id: fileItem.uid,
          Nombre: fileItem.name,
        });
      });
    }

    function eliminarEstadoFinanciero(file: any) {
      objetoFinanciera.TamañoArchivo -= Number(file.size);

      objetoFinanciera.Documentos.ExtensionesArchivos = objetoFinanciera.Documentos.ExtensionesArchivos.filter(
        (ext: any) => ext.Id !== file.uid
      );

      objetoFinanciera.NombresArchivos = objetoFinanciera.NombresArchivos.filter(
        (nom: any) => nom.Id !== file.uid
      );

      objetoFinanciera.Archivos.delete(file.uid);
    }
    
    const reiniciarObjetoFinanciera = () => {
      estadosFinancieros.value = [];
      justificarIngresos.value = false;

      objetoFinanciera.IngresosOperacionales = 0;
      objetoFinanciera.IngresosNoOperacionales = 0;
      objetoFinanciera.JustificacionIngresos = "";
      objetoFinanciera.Archivos = new FormData();
      objetoFinanciera.TamañoArchivo = 0;
      objetoFinanciera.BuenasPracticas = "";
      objetoFinanciera.NombresArchivos = [];
      objetoFinanciera.Documentos.ExtensionesArchivos = [
        {
          Id: 0,
          Extension: "application/default",
        },
      ];
    };

    onMounted(() => {
      reiniciarObjetoFinanciera();
    });


    return {
      estadosFinancieros,
      validacionFinanciera,
      objetoFinanciera,
      store,
      justificarIngresos,
      reiniciarObjetoFinanciera,
      validarIngresos,
      cargarEstadoFinanciero,
      eliminarEstadoFinanciero,
    };
  },
});
